function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var automationIdInjectionEnabled = true;
var defaultTestAttribute = 'data-cvent-id';
/**
 * Enables the injection of test is via the resolveTestId and injectTestId methods.
 **/

function enableAutomationSupport() {
  automationIdInjectionEnabled = true;
}
/**
 * Disables the injection of test is via the resolveTestId and injectTestId methods.
 **/

function disableAutomationSupport() {
  automationIdInjectionEnabled = false;
}
/**
 * Sets a default test attribute to use if one is not provided when calling
 * resolveTestId or injectTestId. Defaults to 'data-cvent-id'
 **/

function setDefaultTestAttribute(newDefaultTestAttribute) {
  if (!newDefaultTestAttribute.startsWith('data-')) {
    throw new Error('test automation attribute must be valid data-* attribute');
  }

  defaultTestAttribute = newDefaultTestAttribute;
}
/**
 * Creates an object with a key value pair with the form { [testAttributeName]: id }.
 * The id is created from the test attribute found in props and the provided
 * postfix. If the test attribute is not present then an empty object is
 * returned. The resulting object can be spread into a dom element to be used
 * by tools such as XPath to locate a specific html element.
 *
 * This is a legacy method maintained for backwards compatibility. Ideally the
 * testId should be known and not pulled out by this method. Please see the
 * readme for more information.
 **/

function resolveTestId(props) {
  var postFix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var testAttributeName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultTestAttribute;
  var attributePresent = props && props.hasOwnProperty(testAttributeName);
  return automationIdInjectionEnabled && attributePresent ? _defineProperty({}, testAttributeName, "".concat(props[testAttributeName]).concat(postFix)) : {};
}
/**
 * Creates an object with a key value pair with the form { [testAttributeName]: testId }.
 * If the testId is empty then an empty object is returned. The resulting object
 * can be spread into a dom element to be used by tools such as XPath to
 * locate a specific html element.
 *
 * In some cases this method may be used to create an ID which is then spread
 * into a custom react component to then later be picked up by the
 * resolveTestId method. Note that this is not the preferred approach any more
 * and simply passing a TestId to a component is preferred. Please see the
 * README for more information.
 *
 * @param {string} testId - The id used as the value for the data attribute.
 * @param {string} testAttributeName - The key defining the data attribute.
 */

function injectTestId(testId) {
  var testAttributeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTestAttribute;
  return automationIdInjectionEnabled && testId ? _defineProperty({}, testAttributeName, testId) : {};
}

export { enableAutomationSupport, disableAutomationSupport, setDefaultTestAttribute, resolveTestId, injectTestId };
//# sourceMappingURL=index.js.map
